import type { GameManifest } from "../../contracts/game";

export const carcadeCityManifest: GameManifest = {
  id: "carcade-city",
  title: "CARCADE City",
  version: "0.2.0",
  status: "playable",
  // Use the exact CARCADE Building-category illustration already visible in
  // the owner's launcher reference rather than a second flat/programmer-art
  // city tile. The game and category intentionally share this shell artwork.
  coverAsset: "/system/categories/building.jpg",
  catalogOrder: 5,
  preferredAspectRatio: 16 / 10,
  supportsCpu: false,
  offline: "online-only",
  load: () => import("./index"),
};
